export const formOfPaymentMap = {
  0: "CASH",
  1: "CREDIT CARD",
  2: "CC charged by Agency",
  3: "Debit Card",
  4: "No Payment Invoice",
  5: "CLIENT CREDIT",
} as const;

export const fopWithDescription = [
  {
    description: "No Payment Invoice",
    fop: 4,
    bankNumber: null,
    bankAccount: null,
  },
  {
    description: "CASH",
    fop: 0,
    bankNumber: null,
    bankAccount: null,
    invalid: true,
  },
  {
    description: "CHEQUE",
    fop: 0,
    bankNumber: null,
    bankAccount: null,
    invalid: true,
  },
  {
    description: "CREDIT CARD",
    fop: 1,
    bankNumber: null,
    bankAccount: "",
  },
  {
    description: "CC charged by Agency",
    fop: 2,
    bankNumber: null,
    bankAccount: null,
  },
  {
    description: "Debit Card",
    fop: 3,
    bankNumber: null,
    bankAccount: null,
    invalid: true,
  },
  {
    description: "CLIENT CREDIT",
    fop: 5,
    bankNumber: "CLCredit",
    bankAccount: null,
  },
  {
    description: "INTERAC TO HEAD OFFICE",
    fop: 0,
    bankNumber: "INTERAC",
    bankAccount: "0000001030",
    currencyCode: "CAD",
  },
  {
    description: "USD CREDIT/VOUCHER",
    fop: 1,
    bankNumber: "CR USD",
    bankAccount: null,
    currencyCode: "USD",
  },
  {
    description: "GBP CREDIT/VOUCHER",
    fop: 1,
    bankNumber: "CR GBP",
    bankAccount: null,
    currencyCode: "GBP",
  },
  {
    description: "EUR CREDIT/VOUCHER",
    fop: 1,
    bankNumber: "CR EUR",
    bankAccount: null,
    currencyCode: "EUR",
  },
  {
    description: "CAD CC CHARGED IN HOUSE BY TTAND",
    fop: 2,
    bankNumber: "CC ",
    bankAccount: "0000001030",
    currencyCode: "CAD",
  },
  {
    description: "CREDIT/VOUCHER CAD",
    fop: 1,
    bankNumber: "CR RED.",
    bankAccount: "",
    currencyCode: "CAD",
  },
  {
    description: "USD CC CHARGED IN HOUSE BY TTAND",
    fop: 2,
    bankNumber: "USD CC",
    bankAccount: "0000001040",
    currencyCode: "USD",
  },
  {
    description: "CREDIT/VOUCHER USD",
    fop: 1,
    bankNumber: "CR RED USD",
    bankAccount: null,
    currencyCode: "USD",
  },
  {
    description: "CHQ CDN TRUST",
    fop: 0,
    bankNumber: "CHQ CDN T",
    bankAccount: "0000001030",
    currencyCode: "CAD",
  },
  {
    description: "CHQ USD TRUST",
    fop: 0,
    bankNumber: "CHQ USD T",
    bankAccount: "0000001040",
    currencyCode: "USD",
  },
  {
    description: "CASH CAD TRUST",
    fop: 0,
    bankNumber: "CASH CAD T",
    bankAccount: "0000001030",
    currencyCode: "CAD",
  },
  {
    description: "GIFT CERTIFICATE",
    fop: 0,
    bankNumber: "GIFT CERT",
    bankAccount: "0000001123",
    currencyCode: "CAD",
    invalid: true,
  },
  {
    description: "REFERRAL PROG CREDIT",
    fop: 0,
    bankNumber: "REF PROG",
    bankAccount: "",
    currencyCode: "CAD",
    invalid: true,
  },
  {
    description: "CASH USD GENERAL",
    fop: 0,
    bankNumber: "CASH USD G",
    bankAccount: "0000001020",
    currencyCode: "USD",
    invalid: true,
  },
  {
    description: "FLEXITI AMEX",
    fop: 1,
    bankNumber: "CCFLEX",
    bankAccount: null,
    currencyCode: "CAD",
    invalid: true,
  },
  {
    description: "CHQ USD GENERAL",
    fop: 0,
    bankNumber: "CHQ USD GE",
    bankAccount: "0000001020",
    currencyCode: "USD",
    invalid: true,
  },
  {
    description: "CHQ CDN GENERAL",
    fop: 0,
    bankNumber: "CHQ CDN G",
    bankAccount: "0000001010",
    currencyCode: "CAD",
    invalid: true,
  },
  {
    description: "CASH USD TRUST",
    fop: 0,
    bankNumber: "CASH USD T",
    bankAccount: "0000001040",
    currencyCode: "USD",
  },
  {
    description: "CASH CDN GENERAL",
    fop: 0,
    bankNumber: "CASH CDN G",
    bankAccount: "0000001010",
    currencyCode: "CAD",
    invalid: true,
  },
];
